<template>
    <form @submit.prevent="submit" class="flex flex-wrap md:flex-no-wrap flex-row -mx-2">
        <div class="w-full md:w-1/2 md:px-2">
            <div class="relative">
                <select class="appearance-none bg-white pl-4 pr-8 py-3 text-grey-darker rounded w-full block mb-3 outline-0" v-model="type" required>
                    <option :value="null" disabled>{{ $t('Select_a_medical_practice') }}</option>
                    <option v-for="type in sortedTypes" :key="type.key" :value="type.key">{{ type.label }}</option>
                </select>
                <div class="pointer-events-none absolute pin-t h-10 pt-1 pin-r flex items-center px-2 text-grey-darker">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
        </div>
        <div class="w-full md:w-1/2 md:px-2">
            <div class="relative">
                <button
                    type="button"
                    @click.prevent="geolocate"
                    class="absolute pin-r py-2 px-2 text-2xl"
                    :class="isGeolocating || isGeolocated ? 'text-blue' : 'text-grey hover:text-grey-darkest'">
                    <span class="icon"><i class="mdi mdi-crosshairs-gps" :class="isGeolocating ? 'animated infinite pulse' : ''"></i></span>
                </button>
                <gmap-autocomplete
                    @place_changed="setPlace"
                    :selectFirstOnEnter="true"
                    :options="autocompleteOptions"
                    :value="isGeolocated ? '' : patientPlace"
                    :placeholder="patientPlace ? patientPlace : $t('Enter_a_location')"
                    id="search-form-field"
                    class="bg-white px-4 py-3 text-grey-darker rounded w-full block mb-3 outline-0 z-0"
                    ></gmap-autocomplete>
            </div>
        </div>
        <!-- <div class="w-full md:w-auto md:px-2">
            <button type="submit" class="inline-flex items-center bg-blue-dark hover:bg-blue-darker text-white px-4 py-3 uppercase tracking-wide font-semibold rounded mb-3 w-full justify-center">
                <span class="icon"><i class="mdi mdi-magnify"></i></span>
                <span class="md:hidden text-sm ml-2">Search</span>
            </button>
        </div> -->
    </form>
</template>
<script>
    import _sortBy from 'lodash/sortBy'
    import helpers from '@/mixins/helpers'

    export default {
        name: 'search-form',

        mixins: [helpers],

        data: () => ({
            autocompleteOptions: {
                types: ['(regions)'],
                componentRestrictions: { country: 'be' }
            },
            isGeolocated: false,
            isGeolocating: false,
            google: null,
            type: null,
            place_id: null,
            types: [
                'DENTIST',
                'GENERAL_PRACTITIONER',
                'GYNECOLOGIST',
                'OPHTHALMOLOGIST',
                'PEDIATRICIAN',
                'PSYCHOLOGIST',
                'DERMATOLOGIST',
                'OSTEOPATH',
                'PSYCHIATRIST',
                'PHYSIOTHERAPIST',
            ]
        }),

        computed: {
            sortedTypes () {
                return _sortBy(this.types.map(type => {
                    return {
                        key: type,
                        label: this.$t('type_' + type)
                    }
                }), 'label')
            }
        },

        mounted () {
            this.type = this.$route.query.type || this.patientMedicalPractice || localStorage.getItem('medicalPractice')

            if (! this.isGeolocating && ! this.isGeolocated && ! this.patientPlace) {
                if (this.$route.query.lat && this.$route.query.long) {
                    this.isGeolocated = true
                    this.setPatientPlace(this.$t('Your_current_position'))
                    this.setPatientPosition({
                        _lat: this.$route.query.lat,
                        _long: this.$route.query.long
                    })

                    this.submit()
                } else {
                    let place = this.$route.query.place || localStorage.getItem('patientPlace')
                    if (place && place !== 'null' && place !== null) {
                        this.useGoogleToSetPlace(place)
                    } else {
                        this.geolocate()
                    }
                }
            }
        },

        methods: {
            useGoogleToSetPlace(place) {
                if (typeof window.google === 'undefined') {
                    setTimeout(() => {
                        this.useGoogleToSetPlace(place)
                    }, 500)

                    return false;
                }
                if (window.google && window.google.maps && window.google.maps.places) {
                    let service = new window.google.maps.places.PlacesService(document.getElementById('search-form-field'))

    
                    service.getDetails({
                        placeId: place
                    }, (place, status) => {
                        if (status == 'OK') {
                            this.setPlace(place)
                        } else {
                            this.geolocate()
                        }
                    })
                }
            },

            geolocate () {
                this.isGeolocating = true

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.isGeolocated = true
                        this.setPatientPlace(this.$t('Your_current_position'))
                        this.setPatientPosition({
                            _lat: position.coords.latitude,
                            _long: position.coords.longitude
                        })

                        this.isGeolocating = false

                        this.submit()
                    }, () => {
                        this.isGeolocating = false
                    });
                } else {
                    setTimeout(() => {
                        this.isGeolocating = false
                    }, 1000)
                }
            },

            setPlace (place) {
                this.isGeolocated = false
                this.place_id = place.place_id
                if (place.geometry) {
                    this.setPatientPlace(place.formatted_address)
                    this.setPatientPlaceName(place.name)
                    this.setPatientPosition({
                        _lat: place.geometry.location.lat(),
                        _long: place.geometry.location.lng()
                    })
                } else {
                    this.setPatientPlace('')
                    this.setPatientPlaceName('')
                    this.setPatientPosition(null)
                }

                this.submit()
            },

            submit () {
                if (this.type === null) {
                    return false
                }

                this.setPatientMedicalPractice(this.type)

                this.$router.push({ query: { type: this.type, place: this.place_id } })

                this.$emit('input', { type: this.type, place: this.place_id })

                this.$emit('submit')

                this.$ga.event({
                    eventCategory: 'SearchTimeSlot',
                    eventAction: 'Location',
                    eventLabel: this.patientPlaceName
                })

                this.$ga.event({
                    eventCategory: 'SearchTimeSlot',
                    eventAction: 'MedicalPractice',
                    eventLabel: this.type
                })
            }
        },

        watch: {
            place_id (newValue, oldValue) {
                localStorage.setItem('patientPlace', newValue);
            },
            type (newValue, oldValue) {
                localStorage.setItem('medicalPractice', newValue);
                this.submit()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/SearchForm.vue